export enum UserExistsExceptionCode {
  BOTH_NOT_FOUND = 'BOTH_NOT_FOUND',
  BOTH_REGISTERED = 'BOTH_REGISTERED',
  EMAIL_ADDRESS_REGISTERED = 'EMAIL_ADDRESS_REGISTERED',
  PHONE_NUMBER_REGISTERED = 'PHONE_NUMBER_REGISTERED',
}
